/* eslint-disable no-nested-ternary */
import { Person, SmartToy } from '@mui/icons-material';
import { Avatar, Box, Typography, useTheme } from '@mui/material';
import type React from 'react';

interface MessageData {
  id: string;
  text: string;
  sender: 'user' | 'ai';
  timestamp: Date;
}

interface MessageProps {
  message: MessageData;
}

export const Message: React.FC<MessageProps> = ({ message }) => {
  const theme = useTheme();

  const isUser = message.sender === 'user';

  const messageContainerStyles = {
    display: 'flex',
    flexDirection: isUser ? 'row-reverse' : ('row' as const),
    alignItems: 'flex-start',
    gap: '8px',
    marginBottom: '8px',
  };

  const messageBoxStyles = {
    maxWidth: '75%',
    padding: '12px 16px',
    borderRadius: isUser ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
    backgroundColor: isUser ? theme.palette.secondary.dark : '#ffffff',
    color: isUser ? 'white' : '#333333',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    wordWrap: 'break-word' as const,
  };

  const avatarStyles = {
    width: 32,
    height: 32,
    backgroundColor: isUser ? theme.palette.secondary.dark : theme.palette.secondary.main,
  };

  const timestampStyles = {
    fontSize: '11px',
    color: '#666666',
    marginTop: '4px',
    textAlign: isUser ? 'right' : ('left' as const),
  };

  return (
    <Box sx={messageContainerStyles}>
      <Avatar sx={avatarStyles}>
        {isUser ? <Person sx={{ fontSize: 18 }} /> : <SmartToy sx={{ fontSize: 18 }} />}
      </Avatar>

      <Box
        sx={{
          flex: 1,
          ...(isUser ? { display: 'flex', flexDirection: 'column', alignItems: 'end' } : {}),
        }}>
        <Box sx={messageBoxStyles}>
          <Typography variant="body2" sx={{ lineHeight: 1.4 }}>
            {message.text}
          </Typography>
        </Box>
        <Typography sx={timestampStyles}>
          {message.timestamp.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
          })}
        </Typography>
      </Box>
    </Box>
  );
};
